exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-icon{width:234px;height:302px}.text{font-size:24px;line-height:28px;max-width:350px}", ""]);

// exports
